import { useState } from 'react';
import { Building, MapPin, ChevronDown, ChevronUp } from 'lucide-react';
import useLogoBackground from '../../hooks/useLogoBackground';

const ProfileInformationSection = ({ profile }) => {
  const logoBackground = useLogoBackground(profile?.logo);
  const [expanded, setExpanded] = useState(false);
  const businessName = profile?.business_name || 'Your Business';
  const descriptionText =
    profile?.description || 'Add a short description to personalize your feed.';

  return (
    <div
      className='rounded-xl p-6 flex flex-col md:flex-row items-start md:items-center gap-6'
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
      }}
    >
      <div
        className='h-20 w-20 rounded-xl flex items-center justify-center shrink-0'
        style={{
          background: logoBackground === 'dark' ? 'var(--bg-card-alt)' : 'var(--bg-surface)',
          border: '1px solid var(--border)',
        }}
      >
        {profile?.logo ? (
          <img
            src={profile.logo}
            alt='Business Logo'
            className='h-12 w-12 object-contain'
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/600x400/png?text=No+Logo';
            }}
          />
        ) : (
          <span className='text-2xl font-semibold' style={{ color: 'var(--text-body)' }}>
            {businessName.charAt(0).toUpperCase()}
          </span>
        )}
      </div>

      <div className='flex-grow'>
        <h1 className='text-2xl font-bold' style={{ color: 'var(--text-primary)' }}>
          {businessName}
        </h1>
        <p className='mt-1 text-sm' style={{ color: 'var(--text-muted)' }}>
          Welcome back, this is a preview version! Here&apos;s what&apos;s happening with your content.
        </p>
        {(descriptionText || profile?.industry || profile?.city) && (
          <div className='md:hidden mt-2'>
            <button
              type='button'
              className='flex items-center gap-1 text-xs font-medium'
              style={{ color: 'var(--text-muted)' }}
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded ? (
                <>Less <ChevronUp className='w-3.5 h-3.5' /></>
              ) : (
                <>More <ChevronDown className='w-3.5 h-3.5' /></>
              )}
            </button>
          </div>
        )}

        <div className={`${expanded ? 'block' : 'hidden'} md:block`}>
          {descriptionText && (
            <p className='text-xs mt-3 max-w-3xl leading-relaxed' style={{ color: 'var(--text-muted)' }}>
              {descriptionText}
            </p>
          )}

          {(profile?.industry || profile?.city) && (
            <div className='mt-4 flex flex-wrap gap-2'>
              {profile?.industry && (
                <span
                  className='inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium'
                  style={{
                    background: 'var(--bg-surface)',
                    color: 'var(--text-body)',
                    border: '1px solid var(--border)',
                  }}
                >
                  <Building className='w-4 h-4' /> {profile.industry}
                </span>
              )}
              {profile?.city && (
                <span
                  className='inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium'
                  style={{
                    background: 'var(--bg-surface)',
                    color: 'var(--text-body)',
                    border: '1px solid var(--border)',
                  }}
                >
                  <MapPin className='w-4 h-4' /> {profile.city}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileInformationSection;
